import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=57d0318c&scoped=true"
import script from "./GlobalSearch.vue?vue&type=script&lang=js"
export * from "./GlobalSearch.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearch.vue?vue&type=style&index=0&id=57d0318c&prod&lang=scss&scoped=true"
import style1 from "./GlobalSearch.vue?vue&type=style&index=1&id=57d0318c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d0318c",
  null
  
)

export default component.exports